var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ais-instant-search",
        {
          attrs: { "search-client": _vm.searchClient, "index-name": _vm.index },
        },
        [
          _c("ais-configure", {
            attrs: { distinct: true, facetFilters: _vm.facetFilters() },
          }),
          _vm._v(" "),
          _c(
            "ais-hits",
            { staticClass: "app-content", attrs: { role: "main" } },
            [
              _c("icon-does-not-exist", {
                staticClass: "app-content",
                attrs: {
                  "icon-name": "packs",
                  "selected-style": "solid",
                  "selected-family": "classic",
                  version: _vm.version,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }